/* Lighted Address Numbers: "from $72" price line for the customizer.
   Version 3 (Sept 10, 2026).
   - The "$72" line is shown and the theme's own price is hidden as soon as the page is ready
     (version 2), so nothing jumps when the customizer loads.
   - New in version 3: when the customer starts typing their numbers, the theme's price is only
     shown once the customizer has written the real price into it. Before, it was shown at once,
     so the store's $1 placeholder price was visible for about a third of a second until the
     customizer caught up. The "$72" line already follows the size buttons ($81, $90 ...), so
     whatever size is selected is what stays on screen until the real total arrives. */
(function () {
  /* The theme's price element is looked up fresh every time, in case the customizer replaces it */
  function priceContainer() { return document.querySelector('.price-list--product'); }
  function salePriceElement() { var c = priceContainer(); return c ? c.querySelector('sale-price') : null; }

  var first_container = priceContainer();
  if (!first_container) { return; }

  /* What the theme's price says before the customizer touches it (the $1 placeholder).
     "Sale price" is a hidden label for screen readers; spaces are ignored so the comparison
     is not fooled by formatting. */
  function normalise(text) { return String(text).replace(/sale price/i, '').replace(/\s+/g, ''); }
  var first_sale_price = salePriceElement();
  var placeholder_text = first_sale_price ? normalise(first_sale_price.textContent) : '';
  function realPriceReady() {
    var el = salePriceElement();
    return !!el && normalise(el.textContent) !== placeholder_text;
  }

  /* 1. Show the "$72" line right away and hide the theme's price, so nothing moves later */
  var new_price = document.createElement('p');
  new_price.classList.add('text-money');
  new_price.classList.add('text-large');
  new_price.innerText = '$72';
  first_container.insertAdjacentElement('afterend', new_price);

  function showStartingPrice() {
    var c = priceContainer();
    if (c) { c.style.setProperty('display', 'none', 'important'); }
    new_price.style.setProperty('display', 'block', 'important');
  }
  function showRealPrice() {
    var c = priceContainer();
    if (c) { c.style.setProperty('display', 'block', 'important'); }
    new_price.style.setProperty('display', 'none', 'important');
  }
  showStartingPrice();

  /* 2. Size buttons in the customizer change the number (wired once the customizer exists) */
  var prices = {
    '._pplr_5': '$72',
    '._pplr_6': '$81',
    '._pplr_8': '$90',
    '._pplr_10': '$98',
    '._pplr_12': '$110',
    '._pplr_14': '$125'
  };

  function wireSizeButtons() {
    Object.keys(prices).forEach(function (selector) {
      var button = document.querySelector(selector);
      if (button) {
        button.addEventListener('click', function () { new_price.innerText = prices[selector]; });
      }
    });
  }

  function waitForZepto(callback) {
    if (document.querySelectorAll('.pplr_monogram').length !== 0) {
      callback();
    } else {
      var interval = setInterval(function () {
        if (document.querySelectorAll('.pplr_monogram').length !== 0) {
          clearInterval(interval);
          callback();
        }
      }, 100);
    }
  }
  waitForZepto(wireSizeButtons);

  /* 3. Once the customer types their numbers, show the customizer's real price instead of "$72",
        but only after the customizer has actually written it (never the $1 placeholder). */
  var waiting_for_real_price = false;

  function swapIfReady() {
    if (waiting_for_real_price && realPriceReady()) {
      waiting_for_real_price = false;
      showRealPrice();
    }
  }
  /* Main path: react the instant the customizer writes into the price element */
  var watcher = new MutationObserver(swapIfReady);
  watcher.observe(first_container.parentElement || first_container, { childList: true, characterData: true, subtree: true });
  /* Safety net: also look four times a second while waiting, in case a change is missed */
  setInterval(swapIfReady, 250);

  document.addEventListener('input', function (e) {
    if (!e.target.matches('input.pplraddprice.p_u_t')) { return; }
    var val = e.target.value.trim();
    if (val.length > 0) {
      if (realPriceReady()) {
        waiting_for_real_price = false;
        showRealPrice();
      } else {
        waiting_for_real_price = true;   /* keep the starting price on screen until the real price arrives */
      }
    } else {
      waiting_for_real_price = false;
      showStartingPrice();
    }
  });
})();